/*
 * Title: Leaderboard/Navigation.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Leaderboard tabs navigation
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";

type Props = {};
const Navigation: React.FC<Props> = (props) => {
  const creator = useSelector((state: any) => state?.creator);

  const cname = creator.creator?.username;
  const pname = creator.program?.name;

  const primary = "var(--tile-inlay-primary)";
  const { pathname } = useLocation();

  return (
    <div className="flex w-full">
      <NavLink
        to={`/${cname}/${pname}/leaderboard/all-fans`}
        style={{
          color: "#fff",
          borderColor: ["/leaderboard", "/leaderboard/all-fans"].includes(
            pathname
          )
            ? primary
            : null,
          fontWeight: ["/leaderboard", "/leaderboard/all-fans"].includes(
            pathname
          )
            ? "500"
            : "400",
        }}
        className="hover:bg-white/[0.05] border-b-[#fff]/20  text-center w-full py-2.5 lg:text-[18px] text-[14px] tabs-after border-b leading-5 tile-inlay-primary outline-none uppercase">
        All Fans
      </NavLink>
      {/* <NavLink
        to="/leaderboard/known-fans"
        style={({ isActive }) => ({
          color: "#fff",
          borderColor: isActive ? primary : null,
          fontWeight: isActive ? "550" : "400",
        })}
        className="hover:bg-white/[0.05] border-b-[#fff]/20 text-center w-full py-2.5 lg:text-[18px] text-[14px] tabs-after border-b leading-5 text-white outline-none uppercase">
        Fans i know
      </NavLink> */}
    </div>
  );
};

export default Navigation;
